/**
 * English language pack
 */

export default {
  // Common
  common: {
    ok: 'OK',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    save: 'Save',
    reset: 'Reset',
    search: 'Search',
    clear: 'Clear',
    refresh: 'Refresh',
    export: 'Export',
    import: 'Import',
    upload: 'Upload',
    download: 'Download',
    view: 'View',
    detail: 'Detail',
    back: 'Back',
    submit: 'Submit',
    close: 'Close',
    loading: 'Loading...',
    noData: 'No Data',
    total: 'Total',
    items: 'items',
    page: 'Page',
    go: 'Go',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    yes: 'Yes',
    no: 'No',
    enable: 'Enable',
    disable: 'Disable',
    statusLabel: 'Status',
    action: 'Action',
    actions: 'Actions',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    remark: 'Remark',
    sort: 'Sort',
    more: 'More',
    expand: 'Expand',
    collapse: 'Collapse',
    of: 'of',
    enterprise: 'Enterprise',
    user: 'User',
    settings: 'Settings',
    // Status values
    status: {
      active: 'Active',
      inactive: 'Inactive',
      archived: 'Archived',
    },
  },

  // Exception pages
  exception: {
    notFound: 'Sorry, the page you visited does not exist.',
    forbidden: 'Sorry, you do not have permission to access this page.',
    serverError: 'Sorry, the server encountered an error.',
    backHome: 'Back to Home',
    backPrevious: 'Go Back',
    refresh: 'Refresh Page',
  },

  // Table
  table: {
    columnSettings: 'Column Settings',
    selectAll: 'Select All',
    columnSettingsTip: 'Drag to adjust column order, click checkbox to show/hide columns',
  },

  // Form Extended
  form: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    phone: 'Please enter a valid phone number',
    password: 'Password should be 6-20 characters',
    confirmPassword: 'The two passwords are inconsistent',
    username: 'Username should be 3-20 characters',
    select: 'Please select',
    input: 'Please input',
    upload: 'Please upload file',
    date: 'Please select date',
    time: 'Please select time',
    number: 'Please enter a number',
    url: 'Please enter a valid URL',
    idCard: 'Please enter a valid ID card number',
    bankCard: 'Please enter a valid bank card number',
    zipCode: 'Please enter a valid zip code',
    startDate: 'Start Date',
    endDate: 'End Date',
  },

  // Menu
  menu: {
    home: 'Home',
    dashboard: 'Dashboard',
    workplace: 'Workplace',
    analysis: 'Analysis',
    monitor: 'Monitor',
    
    product: 'Product Management',
    productList: 'Product List',
    productAdd: 'Add Product',
    productEdit: 'Edit Product',
    productCategory: 'Product Category',
    categoryList: 'Category Management',
    productBrand: 'Brand Management',
    brandList: 'Brand Management',
    labelList: 'Label Management',
    templateList: 'Template Management',
    productUnit: 'Unit Management',
    productSku: 'SKU Management',
    skuList: 'SKU List',
    moqTemplateList: 'MOQ Templates',
    categoryShipmentTemplateList: 'Category MOQ Templates',
    priceMonitor: 'Price Monitor',
    productConfig: 'Product Config',
    businessOrder: 'Business Order',

    inventory: 'Inventory Management',
    inventoryList: 'Inventory List',
    inventoryInbound: 'Inbound Management',
    inventoryOutbound: 'Outbound Management',
    inventoryTransfer: 'Inventory Transfer',
    inventoryCheck: 'Inventory Check',
    
    order: 'Order Management',
    orderList: 'Order List',
    orderDetail: 'Order Detail',
    orderRefund: 'Refund Management',
    orderAfterSale: 'After-sale Management',
    salesOrder: 'Sales Order',
    pendingApproval: 'Pending Approval',
    purchaseOrder: 'Purchase Order',
    returnOrder: 'Return Order',
    purchaseAfterSales: 'Purchase After-Sales',
    salesAfterSales: 'Sales After-Sales',
    paymentRecord: 'Payment Records',
    orderStatistics: 'Order Statistics',
    cart: 'Cart',
    mall: 'Procurement Mall',

    customer: 'Customer Management',
    customerList: 'Customer List',
    customerCategory: 'Customer Categories',
    customerQuotes: 'Quotations',
    customerPrices: 'Customer Pricing',
    customerProducts: 'Product Authorization',
    customerGroup: 'Customer Group',
    customerLevel: 'Customer Level',
    customerLevels: 'Customer Levels',
    levelPrices: 'Level Prices',
    salesmen: 'Salesmen',
    customerInfo: 'Customer Info',
    customerType: 'Customer Type',

    finance: 'Finance Management',
    financeAccount: 'Account Management',
    financeFlow: 'Capital Flow',
    financeStatement: 'Financial Statement',
    
    marketing: 'Marketing Management',
    marketingCoupon: 'Coupon',
    marketingPromotion: 'Promotion',
    marketingMember: 'Member Management',
    
    content: 'Content Management',
    contentArticle: 'Article Management',
    contentBanner: 'Banner',
    contentNotice: 'Notice Management',
    
    system: 'System Management',
    systemUser: 'User Management',
    systemRole: 'Role Management',
    systemPermission: 'Permission Management',
    systemDept: 'Department Management',
    systemDict: 'Dictionary Management',
    systemConfig: 'System Config',
    systemLog: 'Operation Log',
    systemMenu: 'Menu Management',
    
    personal: 'Personal Center',
    personalInfo: 'Personal Info',
    personalPassword: 'Change Password',
    personalSetting: 'Personal Setting',

    // Admin Mode
    adminMode: 'Admin Mode',
    businessMode: 'Business Mode',
    adminDashboard: 'Admin Dashboard',
    tenantSettings: 'Tenant Settings',
    openapiApps: 'OpenAPI Apps',
    organization: 'Organization',
    tenantManagement: 'Tenant Management',
    subTenantManagement: 'Sub-Tenant Management',
    organizationManagement: 'Organization Management',
    memberManagement: 'Member Management',
    themeConfig: 'Theme Configuration',

    // Admin Mode - Functional Groups
    orgPeople: 'Organization & People',
    systemOrganization: 'Organization',
    systemUsers: 'Users',
    systemPosition: 'Positions',
    accessControl: 'Access Control',
    systemRoles: 'Roles',
    systemPermissions: 'Permissions',
    systemMenus: 'Menus',
    systemDataScope: 'Data Scope',
    systemFieldPermission: 'Field Permissions',
    securityAudit: 'Security & Audit',
    permissionOverride: 'Permission Override',
    permissionTracing: 'Permission Tracing',
    permissionAudit: 'Permission Audit',
    loginLog: 'Login Log',
    auditLog: 'Audit Log',
    messageCenter: 'Message Center',
    subscription: 'My Subscription',
    adminOrders: 'Orders',
    invoices: 'Invoices',
    mallDecoration: 'Mall Decoration',

    // Business Modules
    distributionManagement: 'Distribution',
    productAssign: 'Product Assignment',
    pricingStrategies: 'Pricing Strategies',
    networkTopology: 'Network Topology',
    tradeManagement: 'Trade',
    tradeQuotes: 'Quotes',
    tradeOrders: 'Customer Orders',
    tradeCommission: 'Commission',
    warehouseManagement: 'Warehouse',
    warehouse: 'Warehouse',
    warehousePermissions: 'Warehouse Auth',
    warehouseReceipt: 'Inbound Receipt',
    warehouseList: 'Warehouse List',
    inventoryMgmt: 'Inventory',
    inboundManagement: 'Inbound',
    outboundManagement: 'Outbound',
    stocktakeManagement: 'Stocktake',
    warehouseCarrierConfig: 'Warehouse Carrier Config',
    settlementManagement: 'Settlement',
    settlementList: 'Settlement List',
    creditLine: 'Credit Line',
    settlementRule: 'Settlement Rules',
    reportCenter: 'Reports',
    salesReport: 'Sales Report',
    inventoryReport: 'Inventory Report',
    financeReport: 'Finance Report',
    financeInvoices: 'Invoices',
    financeManagement: 'Finance',
    settlementBills: 'Settlement Bills',
    accounts: 'Accounts',
    financeReceipts: 'Receipts',
    financeDisbursements: 'Disbursements',
    financeFundAccounts: 'Fund Accounts',
    logisticsManagement: 'Logistics',
    shippingCarriers: 'Carriers',
    shipments: 'Shipments',
    logisticsTracking: 'Logistics Tracking',
    carrierPermissions: 'Carrier Permissions',
    promotionManagement: 'Promotions',
    promotionProjects: 'Promotion Projects',
    promotionCoupon: 'Coupons',
    draftOrders: 'Draft Orders',
    channel: 'Channels',
    channelShops: 'Online Shops',
    channelList: 'Channel List',
    cargoManagement: 'Cargo',
    cargoLots: 'Cargo Lots',
    cargoAllocations: 'Cargo Allocation',
    cargoDistributors: 'Distributors',
    cargoProducts: 'Product Assignment',
    cargoPricing: 'Pricing Strategy',
    ycodeManagement: 'Y-Code',
    ycodelist: 'Y-Code List',
    ycodeRedemptions: 'Redemptions',
    ycodePrices: 'Y-Code Pricing',
    productWhitelist: 'Product Whitelist',
    productBundles: 'Product Bundles',
  },

  // Page titles
  title: {
    dashboard: 'Dashboard',
    login: 'Login',
    register: 'Register',
    forgotPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
    profile: 'Profile',
    settings: 'Settings',
    notFound: 'Page Not Found',
    serverError: 'Server Error',
    unauthorized: 'Unauthorized',
    forbidden: 'Forbidden',
  },


  // Messages
  message: {
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    logoutSuccess: 'Logout successful',
    saveSuccess: 'Save successful',
    saveFailed: 'Save failed',
    deleteSuccess: 'Delete successful',
    deleteFailed: 'Delete failed',
    deleteConfirm: 'Are you sure to delete?',
    updateSuccess: 'Update successful',
    updateFailed: 'Update failed',
    uploadSuccess: 'Upload successful',
    uploadFailed: 'Upload failed',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed',
    importSuccess: 'Import successful',
    importFailed: 'Import failed',
    copySuccess: 'Copy successful',
    copyFailed: 'Copy failed',
    networkError: 'Network error',
    serverError: 'Server error',
    paramError: 'Parameter error',
    permissionDenied: 'Permission denied',
    operationSuccess: 'Operation successful',
    operationFailed: 'Operation failed',
    noChanges: 'No changes',
  },

  // Header navigation
  header: {
    profile: 'Profile',
    settings: 'Settings',
    guide: 'User Guide',
    logout: 'Logout',
    notifications: 'Notifications',
    allNotifications: 'View All Notifications',
    search: 'Search',
    help: 'Help',
    support: 'Support',
    language: 'Language',
    theme: 'Theme',
  },

  // Login page
  login: {
    title: 'Coolbuy 3.0',
    subtitle: 'Enterprise PaaS Management Platform',
    username: 'Username',
    password: 'Password',
    remember: 'Remember me',
    forgot: 'Forgot password?',
    login: 'Login',
    register: 'Register account',
    thirdParty: 'Third-party login',
    usernameRequired: 'Please enter username',
    passwordRequired: 'Please enter password',
    loginSuccess: 'Login successful',
    loginFailed: 'Username or password error',
    // New keys for unified login
    usernameLabel: 'Username',
    usernamePlaceholder: 'Please enter username',
    passwordLabel: 'Password',
    passwordPlaceholder: 'Please enter password',
    captcha: 'Captcha',
    captchaLabel: 'Captcha',
    captchaPlaceholder: 'Please enter captcha',
    captchaRequired: 'Please enter captcha',
    captchaInvalid: 'Please enter correct captcha',
    captchaError: 'Failed to get captcha',
    getCaptcha: 'Get Captcha',
    quickLogin: 'Quick Login',
    quickLoginSuccess: 'Quick login successful',
    quickLoginFailed: 'Quick login failed',
    success: 'Login successful',
    failed: 'Login failed',
    welcomeBack: 'Welcome back!',
    errorMessage: 'Username or password error, please try again',
  },

  // Settings
  settings: {
    title: 'System Settings',
    language: 'Language',
    theme: 'Theme',
    layout: 'Layout',
    navigation: 'Navigation',
    content: 'Content Area',
    footer: 'Footer',
    other: 'Other Settings',
    
    lightTheme: 'Light Theme',
    darkTheme: 'Dark Theme',
    autoTheme: 'Follow System',
    
    sideLayout: 'Side Layout',
    topLayout: 'Top Layout',
    mixLayout: 'Mix Layout',
    
    fixedHeader: 'Fixed Header',
    fixedSidebar: 'Fixed Sidebar',
    showTabs: 'Show Tabs',
    showBreadcrumb: 'Show Breadcrumb',
    showFooter: 'Show Footer',
    
    compactMode: 'Compact Mode',
    weakMode: 'Weak Mode',
    colorBlind: 'Color Blind Mode',
    
    reset: 'Reset Default',
    resetConfirm: 'Are you sure to reset to default settings?',
  },

  // Workplace
  workplace: {
    welcome: 'Good morning, {{name}}, have a nice day!',
    welcomeSystem: 'Welcome to the system, today is',
    quickNav: 'Quick Navigation',
    recentVisit: 'Recent Visit',
    myProject: 'My Project',
    quickEntry: 'Quick Entry',
    announcement: 'Announcement',
    todoList: 'Todo List',
    workProgress: 'Work Progress',
    teamActivity: 'Team Activity',
    refreshData: 'Refresh',

    todayData: 'Today Data',
    totalUsers: 'Total Users',
    totalOrders: 'Total Orders',
    totalRevenue: 'Total Revenue',
    newUsers: 'New Users',
    newOrders: 'New Orders',
    todayRevenue: 'Today Revenue',

    // Real-time data
    realTimeData: 'Real-time Data',
    realTime: 'Live',
    todayOrderCount: 'Today Orders',
    todaySalesAmount: 'Today Sales',
    onlineUsers: 'Online Users',
    conversionRate: 'Conversion Rate',

    // System status
    systemStatus: 'System Status',
    normal: 'Normal',
    cpuUsage: 'CPU Usage',
    memoryUsage: 'Memory Usage',
    diskUsage: 'Disk Usage',
    performanceIndex: 'Performance',

    // Charts
    salesTrend: 'Sales Trend',
    regionSales: 'Regional Sales',
    categorySales: 'Category Sales',
    salesAndOrders: 'Sales & Orders',

    chart: {
      orderTrend: 'Order Trend',
      userGrowth: 'User Growth',
      revenueTrend: 'Revenue Trend',
      categoryDistribution: 'Category Distribution',
      regionDistribution: 'Region Distribution',
      last30Days: 'Last 30 Days',
    },
  },

  // Product
  product: {
    title: 'Product Management',
    name: 'Product Name',
    code: 'Product Code',
    category: 'Category',
    brand: 'Brand',
    price: 'Price',
    costPrice: 'Cost Price',
    retailPrice: 'Retail Price',
    wholesalePrice: 'Wholesale Price',
    stock: 'Stock',
    unit: 'Unit',
    spec: 'Specification',
    barcode: 'Barcode',
    description: 'Description',
    image: 'Product Image',
    status: 'Status',
    onSale: 'On Sale',
    offSale: 'Off Sale',
    createProduct: 'Add Product',
    editProduct: 'Edit Product',
    viewProduct: 'View Product',
    deleteProduct: 'Delete Product',
    batchImport: 'Batch Import',
    batchExport: 'Batch Export',
  },

  // Order
  order: {
    title: 'Order Management',
    orderNo: 'Order No.',
    orderType: 'Order Type',
    orderStatus: 'Order Status',
    orderAmount: 'Order Amount',
    payAmount: 'Pay Amount',
    payStatus: 'Pay Status',
    payTime: 'Pay Time',
    customer: 'Customer',
    receiver: 'Receiver',
    receiverPhone: 'Receiver Phone',
    receiverAddress: 'Receiver Address',
    deliveryStatus: 'Delivery Status',
    deliveryTime: 'Delivery Time',
    expressNo: 'Express No.',
    remark: 'Remark',
    createOrder: 'Create Order',
    viewOrder: 'View Order',
    cancelOrder: 'Cancel Order',
    confirmOrder: 'Confirm Order',
    shipOrder: 'Ship Order',
    completeOrder: 'Complete Order',
    refund: 'Refund',
    afterSale: 'After Sale',
    pending: 'Pending',
    paid: 'Paid',
    shipped: 'Shipped',
    completed: 'Completed',
    cancelled: 'Cancelled',
  },

  // Customer
  customer: {
    title: 'Customer Management',
    name: 'Customer Name',
    code: 'Customer Code',
    type: 'Customer Type',
    level: 'Customer Level',
    contact: 'Contact',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    creditLimit: 'Credit Limit',
    balance: 'Balance',
    points: 'Points',
    createCustomer: 'Add Customer',
    editCustomer: 'Edit Customer',
    viewCustomer: 'View Customer',
    deleteCustomer: 'Delete Customer',
  },

  // Inventory
  inventory: {
    title: 'Inventory Management',
    warehouse: 'Warehouse',
    location: 'Location',
    quantity: 'Quantity',
    availableQty: 'Available Qty',
    lockedQty: 'Locked Qty',
    inbound: 'Inbound',
    outbound: 'Outbound',
    transfer: 'Transfer',
    stocktaking: 'Stocktaking',
    inboundNo: 'Inbound No.',
    outboundNo: 'Outbound No.',
    transferNo: 'Transfer No.',
    createInbound: 'Create Inbound',
    createOutbound: 'Create Outbound',
    createTransfer: 'Create Transfer',
  },

  // Finance
  finance: {
    title: 'Finance Management',
    account: 'Account',
    balance: 'Balance',
    income: 'Income',
    expense: 'Expense',
    transaction: 'Transaction',
    transactionNo: 'Transaction No.',
    transactionType: 'Transaction Type',
    transactionAmount: 'Transaction Amount',
    transactionTime: 'Transaction Time',
    receipt: 'Receipt',
    payment: 'Payment',
    statement: 'Statement',
    invoice: 'Invoice',
  },

  // Category
  category: {
    electronics: 'Electronics',
    clothing: 'Clothing',
    books: 'Books',
    home: 'Home',
  },

  // Status
  status: {
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
  },

  // Account Settings
  account: {
    settings: 'Account Settings',
    security: 'Security',
    notification: 'Notifications',
    personalization: 'Personalization',
    binding: 'Account Binding',
    changePassword: 'Change Password',
    twoFactorAuth: 'Two-Factor Auth',
    loginDevices: 'Login Devices',
    loginLog: 'Login Log',
    bindPhone: 'Bind Phone',
    bindEmail: 'Bind Email',
    bindWechat: 'Bind WeChat',
    bindWecom: 'Bind WeCom',
    unbind: 'Unbind',
    bound: 'Bound',
    unbound: 'Unbound',
    securityLevel: 'Security Level',
    securityTips: 'Security Tips',
  },

  // Profile
  profile: {
    title: 'Profile',
    messageCenter: 'Messages',
    myWorkspace: 'My Workspace',
    basicInfo: 'Basic Info',
    avatar: 'Avatar',
    nickname: 'Nickname',
    email: 'Email',
    phone: 'Phone',
    department: 'Department',
    position: 'Position',
    joinDate: 'Join Date',
    noMessages: 'No messages',
    allRead: 'Mark all read',
    unread: 'Unread',
    read: 'Read',
  },

  // System Management
  system: {
    title: 'System Management',
    // User Management
    user: {
      title: 'User Management',
      username: 'Username',
      realName: 'Real Name',
      nickname: 'Nickname',
      email: 'Email',
      phone: 'Phone',
      avatar: 'Avatar',
      status: 'Status',
      role: 'Role',
      department: 'Department',
      position: 'Position',
      createUser: 'Add User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      resetPassword: 'Reset Password',
      assignRole: 'Assign Role',
    },
    // Role Management
    role: {
      title: 'Role Management',
      roleName: 'Role Name',
      roleCode: 'Role Code',
      description: 'Description',
      status: 'Status',
      createRole: 'Add Role',
      editRole: 'Edit Role',
      deleteRole: 'Delete Role',
      assignPermission: 'Assign Permission',
    },
    // Organization Management
    org: {
      title: 'Organization Management',
      orgName: 'Organization Name',
      orgCode: 'Organization Code',
      parentOrg: 'Parent Organization',
      leader: 'Leader',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      sort: 'Sort',
      createOrg: 'Add Organization',
      editOrg: 'Edit Organization',
      deleteOrg: 'Delete Organization',
    },
    // Menu Management
    menu: {
      title: 'Menu Management',
      menuName: 'Menu Name',
      menuType: 'Menu Type',
      icon: 'Icon',
      path: 'Path',
      component: 'Component',
      permission: 'Permission',
      sort: 'Sort',
      visible: 'Visible',
      directory: 'Directory',
      menuItem: 'Menu',
      button: 'Button',
      createMenu: 'Add Menu',
      editMenu: 'Edit Menu',
      deleteMenu: 'Delete Menu',
    },
    // Dictionary Management
    dict: {
      title: 'Dictionary Management',
      dictName: 'Dictionary Name',
      dictCode: 'Dictionary Code',
      dictValue: 'Dictionary Value',
      createDict: 'Add Dictionary',
      editDict: 'Edit Dictionary',
      deleteDict: 'Delete Dictionary',
    },
    // Log Management
    log: {
      title: 'Operation Log',
      operator: 'Operator',
      operateType: 'Operation Type',
      operateTime: 'Operation Time',
      ip: 'IP Address',
      browser: 'Browser',
      os: 'OS',
      result: 'Result',
      detail: 'Detail',
    },
  },

  // Dashboard Overview
  dashboard: {
    overview: 'Overview',
    refresh: 'Refresh',
    today: 'Today',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',

    // Sales Metrics
    salesMetrics: 'Sales Metrics',
    salesAmount: 'Sales Amount',
    orderCount: 'Orders',
    pendingShip: 'Pending Shipment',
    afterSale: 'After-sale Pending',
    vsLastPeriod: 'vs Last Period',
    vsYesterday: 'vs Yesterday',

    // Inventory Metrics
    inventoryMetrics: 'Inventory Metrics',
    skuCount: 'Total SKUs',
    inventoryValue: 'Inventory Value',
    inventoryWarning: 'Inventory Warnings',
    todayInOut: 'Today In/Out',
    newToday: 'New Today',
    clickToView: 'Click to view details',
    inboundOutbound: 'Inbound/Outbound',

    // Charts
    salesTrend: 'Sales Trend',
    turnoverRate: 'Turnover Rate',
    monthlyTurnover: 'Monthly Turnover',
    vsLastMonth: 'vs Last Month',

    // Inventory Warning Modal
    skuCode: 'SKU Code',
    productName: 'Product Name',
    warningType: 'Warning Type',
    currentStock: 'Current Stock',
    safeStock: 'Safe Stock',
    warehouse: 'Warehouse',
    lowStock: 'Low Stock',
    overstock: 'Overstock',
    items: 'items',
    noWarnings: 'No warnings',

    // Status
    increase: 'Increase',
    decrease: 'Decrease',
    noData: 'No Data',
    loadError: 'Failed to load data',
  },

  // IT Management Statistics
  adminStats: {
    itManagement: 'IT Management',
    orgUserStats: 'Organization/Users/Roles',
    logSecurityStats: 'Logs/Security',
    trendAnalysis: 'Trend Analysis',
    distributionAnalysis: 'Distribution Analysis',
    serviceStatus: 'Service Status',
    loadError: 'Failed to load IT statistics',

    // Organization Stats
    organization: 'Organizations',
    subTenants: 'Sub-tenants',
    departments: 'Departments',

    // User Stats
    totalUsers: 'Total Users',
    activeToday: 'Active Today',
    newThisWeek: 'New This Week',
    userStatus: 'User Status',
    activeInactiveDisabled: 'Active/Inactive/Disabled',

    // Role Stats
    totalRoles: 'Total Roles',
    systemRoles: 'System Roles',
    customRoles: 'Custom Roles',

    // Login Log Stats
    todayLogins: 'Today Logins',
    successRate: 'Success Rate',

    // Audit Log Stats
    todayOperations: 'Today Operations',
    highRisk: 'High Risk',
    failed: 'Failed',

    // System Health
    apiPerformance: 'API Performance',
    storageUsage: 'Storage Usage',
    files: 'Files',
    latency: 'Latency',

    // Period Labels
    vsLastPeriod: 'vs Last Period',
    vsYesterday: 'vs Yesterday',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    customRange: 'Custom',
    selectDateRange: 'Select Date Range',

    // Status
    status: {
      online: 'Online',
      offline: 'Offline',
      degraded: 'Degraded',
    },

    // Trend Chart
    trendChart: {
      title: 'IT Trend Analysis',
      userActivity: 'User Activity',
      loginTrend: 'Login Trend',
      auditTrend: 'Audit Trend',
      activeUsers: 'Active Users',
      newUsers: 'New Users',
      successCount: 'Success',
      failCount: 'Failed',
      operationCount: 'Operations',
      highRiskCount: 'High Risk',
    },

    // Distribution Chart
    distributionChart: {
      title: 'Distribution Analysis',
      userStatus: 'User Status',
      roleDist: 'Role Distribution',
      operationType: 'Operation Type',
      deviceType: 'Device Type',
    },

    // Data Labels
    active: 'Active',
    inactive: 'Inactive',
    disabled: 'Disabled',
    system: 'System',
    custom: 'Custom',
    desktop: 'Desktop',
    mobile: 'Mobile',
    tablet: 'Tablet',
    other: 'Other',
  },

  // Organization Management
  organization: {
    // Organization Switcher
    selectOrg: 'Select Organization',
    switchSuccess: 'Switched to {{name}}',
    switchFailed: 'Failed to switch organization',
    primary: 'Primary',
    current: 'Current',
    loadFailed: 'Failed to load organizations',
    selectRequired: 'Please select an organization',
    selectTitle: 'Select Your Organization',
    selectHint: 'Please select the organization you want to work with',

    // Page Title
    title: 'Organization Management',
    description: 'Manage your organization structure',
    treeView: 'List',
    chartView: 'Chart',
    chartViewComingSoon: 'Organization chart view coming soon',

    // Basic Fields
    name: 'Name',
    shortName: 'Short Name',
    code: 'Code',
    status: 'Status',
    level: 'Level',
    path: 'Path',
    sortOrder: 'Sort Order',
    root: 'Root',
    childrenCount: 'Children',

    // Actions
    add: 'Add Organization',
    edit: 'Edit Organization',
    detail: 'Organization Details',
    addChild: 'Add Child',
    deleteConfirm: 'Confirm Delete',
    deleteHint: 'Are you sure you want to delete "{{name}}"?',
    deleteWithChildren: 'This organization has child organizations. Please delete them first.',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Failed to delete',
    createSuccess: 'Created successfully',
    createFailed: 'Failed to create',
    updateSuccess: 'Updated successfully',
    updateFailed: 'Failed to update',
    loadDetailFailed: 'Failed to load details',

    // Form
    parentOrg: 'Parent Organization',
    basicInfo: 'Basic Information',
    contactInfo: 'Contact Information',
    addressInfo: 'Address Information',
    businessInfo: 'Business Information',
    validityPeriod: 'Validity Period',
    systemInfo: 'System Information',

    // Form Fields
    namePlaceholder: 'Enter organization name',
    nameRequired: 'Please enter organization name',
    shortNamePlaceholder: 'Enter short name',
    codePlaceholder: 'Enter organization code',
    codeRequired: 'Please enter organization code',
    codePattern: 'Only letters, numbers, - and _ allowed',
    relationTypeLabel: 'Relation Types',
    relationTypePlaceholder: 'Select relation types',
    relationTypeRequired: 'Please select relation types',

    // Contact Info
    contactName: 'Contact Name',
    contactNamePlaceholder: 'Enter contact name',
    contactPhone: 'Phone',
    contactPhonePlaceholder: 'Enter phone number',
    contactEmail: 'Email',
    contactEmailPlaceholder: 'Enter email',
    emailInvalid: 'Invalid email format',

    // Address Info
    province: 'Province',
    provincePlaceholder: 'Province',
    city: 'City',
    cityPlaceholder: 'City',
    district: 'District',
    districtPlaceholder: 'District',
    region: 'Region',
    address: 'Address',
    addressPlaceholder: 'Enter detailed address',

    // Business Info
    creditCode: 'Credit Code',
    creditCodePlaceholder: 'Enter unified social credit code',
    legalPerson: 'Legal Person',
    legalPersonPlaceholder: 'Enter legal representative',
    bankName: 'Bank Name',
    bankNamePlaceholder: 'Enter bank name',
    bankAccount: 'Bank Account',
    bankAccountPlaceholder: 'Enter bank account',
    validFrom: 'Valid From',
    validTo: 'Valid To',
    remark: 'Remark',
    remarkPlaceholder: 'Enter remark',
    noData: 'No data',

    // Filters
    searchPlaceholder: 'Search by name or code',
    filterByType: 'Filter by type',
    filterByStatus: 'Filter by status',

    // Member Management
    members: 'Members',
    member: 'Member',
    memberRole: 'Role',
    addMember: 'Add Member',
    removeMemberConfirm: 'Remove this member?',
    loadMembersFailed: 'Failed to load members',
    addMemberSuccess: 'Member added successfully',
    addMemberFailed: 'Failed to add member',
    removeMemberSuccess: 'Member removed successfully',
    removeMemberFailed: 'Failed to remove member',
    noMembers: 'No members in this organization',
    selectUser: 'Select User',
    selectUserRequired: 'Please select a user',
    searchUserPlaceholder: 'Search by name or username',
    noUsersFound: 'No users found',
    setPrimary: 'Set as Primary Organization',
    primaryOrg: 'Primary Organization',
    role: {
      admin: 'Administrator',
      manager: 'Manager',
      member: 'Member',
      viewer: 'Viewer',
    },

    // Organization Operations
    move: 'Move',
    moveSuccess: 'Organization moved successfully',
    moveFailed: 'Failed to move organization',
    moveWarning: 'Moving an organization will also move all its child organizations.',
    currentOrg: 'Current Organization',
    newParent: 'New Parent Organization',
    selectNewParent: 'Please select a new parent organization',
    selectParent: 'Select parent organization',
    rootLevel: 'Root Level',

    merge: 'Merge',
    mergeSuccess: 'Organizations merged successfully',
    mergeFailed: 'Failed to merge organizations',
    mergeWarning: 'The source organization will be deleted after merging. All child organizations will be moved to the target organization.',
    sourceOrg: 'Source',
    targetOrg: 'Target',
    selectBelow: 'Select below',
    targetOrganization: 'Target Organization',
    selectTarget: 'Please select target organization',
    selectTargetOrg: 'Select target organization',
    mergeUsers: 'Migrate Users',
    mergeUsersHint: 'If enabled, all users from the source organization will be moved to the target organization.',

    split: 'Split',
    splitSuccess: 'Organization split successfully',
    splitFailed: 'Failed to split organization',
    splitHint: 'Create a new organization from the selected organization. You can optionally move child organizations and users to the new organization.',
    newOrgName: 'New Organization Name',
    newOrgCode: 'New Organization Code',
    sameParent: 'Same Level as Source',
    sameParentHint: 'If enabled, the new organization will be at the same level as the source. Otherwise, it will be a child of the source.',
    moveChildren: 'Move Child Organizations',
    moveUsers: 'Move Users',
    keepInSource: 'Keep in Source',
    moveToNew: 'Move to New',
    noChildren: 'No child organizations',
    noUsers: 'No users in this organization',

    // Relation Types
    relationType: {
      headquarters: 'Headquarters',
      subsidiary: 'Subsidiary',
      branch: 'Branch',
      division: 'Division',
      region: 'Region',
      store: 'Store',
      direct_store: 'Direct Store',
      franchise: 'Franchise',
      dealer: 'Dealer',
      distributor: 'Distributor',
      agent: 'Agent',
      ecommerce: 'E-commerce',
      supplier: 'Supplier',
      manufacturer: 'Manufacturer',
      logistics: 'Logistics',
      warehouse: 'Warehouse',
      customer: 'Customer',
      partner: 'Partner',
    },
  },

  // Business Management
  business: {
    // Customer Relation Management
    customer: {
      title: 'Customer Management',
      myCustomers: 'My Customers',
      asCustomer: 'I as Customer',
      add: 'Add Customer',
      edit: 'Edit Customer',
      createNew: 'Create New',
      addExisting: 'Add Existing Tenant',
      customerName: 'Customer Name',
      customerCode: 'Customer Code',
      relationType: 'Relation Type',
      tenantType: 'Tenant Type',
      industry: 'Industry',
      aliasName: 'Alias Name',
      contactName: 'Contact Name',
      contactPhone: 'Contact Phone',
      ownerName: 'Owner Name',
      ownerCode: 'Owner Code',
      addedAt: 'Added At',
      selfCreated: 'Self Created',
      searchPlaceholder: 'Search name or code',
      filterByRelationType: 'Filter by Relation Type',
      namePlaceholder: 'Enter customer name',
      codePlaceholder: 'Enter customer code',
      aliasNamePlaceholder: 'Enter alias name (optional)',
      contactNamePlaceholder: 'Enter contact name',
      contactPhonePlaceholder: 'Enter contact phone',
      remarksPlaceholder: 'Enter remarks',
      searchTenantPlaceholder: 'Search tenant name or code',
      selectTenant: 'Select Tenant',
      selectTenantPlaceholder: 'Select a tenant to add',
      loadFailed: 'Failed to load customer list',
      addSuccess: 'Customer added successfully',
      addFailed: 'Failed to add customer',
    },
    // Relation Types
    relationType: {
      supplier: 'Supplier',
      distributor: 'Distributor',
      both: 'Both',
    },
    // Visibility Settings
    visibility: {
      title: 'Visibility Settings',
      settings: 'Visibility Settings',
      visibleToAll: 'Visible to All',
      allowTenantTypes: 'Allowed Tenant Types',
      allowIndustries: 'Allowed Industries',
      selectTenantTypes: 'Select allowed tenant types',
      selectIndustries: 'Select allowed industries',
      loadFailed: 'Failed to load visibility settings',
    },
  },

  // Platform Management
  platform: {
    // Tenant Pool Management
    tenantPool: {
      title: 'Tenant Pool Management',
      create: 'Create Pool',
      edit: 'Edit Pool',
      name: 'Pool Name',
      code: 'Pool Code',
      description: 'Description',
      status: 'Status',
      memberCount: 'Members',
      searchPlaceholder: 'Search pool name or code',
      namePlaceholder: 'Enter pool name',
      codePlaceholder: 'Enter pool code (optional)',
      descriptionPlaceholder: 'Enter pool description',
      manageMembers: 'Manage Members',
      addMembers: 'Add Members',
      tenantName: 'Tenant Name',
      tenantCode: 'Tenant Code',
      tenantType: 'Tenant Type',
      industry: 'Industry',
      joinedAt: 'Joined At',
      noAvailableTenants: 'No available tenants to add',
      selectedCount: '{{count}} tenant(s) selected',
      loadFailed: 'Failed to load tenant pools',
      loadMembersFailed: 'Failed to load members',
      loadAvailableTenantsFailed: 'Failed to load available tenants',
      createSuccess: 'Pool created successfully',
      updateSuccess: 'Pool updated successfully',
      deleteSuccess: 'Pool deleted successfully',
      deleteFailed: 'Failed to delete pool',
      deleteConfirm: 'Are you sure to delete pool "{{name}}"? This action cannot be undone.',
      addMembersSuccess: '{{count}} member(s) added successfully',
      addMembersFailed: 'Failed to add members',
      removeMemberSuccess: 'Member removed successfully',
      removeMemberFailed: 'Failed to remove member',
      removeMemberConfirm: 'Are you sure to remove this tenant from the pool?',
    },
  },

  // Changelog
  changelog: {
    title: 'Changelog',
    version: 'Version',
    buildTime: 'Build Time',
    clickToView: 'Click to view changelog',
    loadError: 'Failed to load changelog',
    noData: 'No changelog available',
    type: {
      feature: 'New Features',
      fix: 'Bug Fixes',
      improvement: 'Improvements',
      breaking: 'Breaking Changes',
    },
  },

  // AI Assistant
  aiChat: {
    title: 'AI Assistant',
  },
};